import React from "react";

const ReportFooter = () => (
  <div>
    {/* POS Provider :
    <span className="has-text-weight-bold">
      MSALVIO SOFTWARE & HARDWARE TECHNOLOGIES
    </span>{" "}
    <br />
    Big.D POS v1.0
    <br />
    L10 B4 Villa Socorro Subd. <br />
    Brgy. Taculing <br />
    Bacolod City, Negros Occidental <br />
    Vat Registered TIN: 284-894-233-00000 <br />
    SN: {process.env.REACT_APP_SERIAL} MIN:{process.env.REACT_APP_MIN} <br />
    <br />
    <br /> */}
  </div>
);

export default ReportFooter;
